export default {
    methods: {
        $trackGAEvent(category, action) {
            if (!this.$ga) return;
            try {
                this.$http.post(`/api/investor/public/events`, {
                    gaClientId: this.$getGAClientId(),
                    action: action,
                    category: category,
                    userAgent: window.navigator.userAgent
                })
            } catch (e) {
                console.error(`Failed to track GA event`, e);
            }
        },
        $trackGADataLayerEvent(event, userid) {
            if (!this.$ga) return;
            if (!window.dataLayer) return;
            try {
                window.dataLayer.push({'event': event, userid : userid});
            } catch (e) {
                console.error(`Failed to track GA datalayer event`, e);
            }
        },
        $getGAClientId() {
            if (!window.ga) return;
            try {
                return window.ga.getAll()[0].get('clientId')
            } catch (e) {
                console.error(`Failed to get GA clientId`, e);
            }
        },
    }
}
